const TRUNCATION_MARKER = '…[document truncated — full text available to tools]';
const encoder = new TextEncoder();
function bytes(text) {
    return encoder.encode(text).length;
}
function fitTurnsToWindow(turns, room) {
    const separators = Math.max(0, turns.length - 1);
    const total = turns.reduce((sum, turn)=>sum + bytes(turn), 0) + separators;
    if (total <= room || 0 === turns.length) return [
        ...turns
    ];
    let longest = 0;
    for(let i = 1; i < turns.length; i++)if (bytes(turns[i] ?? '') > bytes(turns[longest] ?? '')) longest = i;
    const turn = turns[longest] ?? '';
    const over = total - room + bytes(TRUNCATION_MARKER);
    const keep = Math.max(0, bytes(turn) - over);
    const chars = [
        ...turn
    ];
    let head = Math.floor(2 * keep / 5);
    let tail = keep - head;
    let cut = `${chars.slice(0, head).join('')}${TRUNCATION_MARKER}${chars.slice(chars.length - tail).join('')}`;
    while(bytes(cut) > bytes(turn) - over + bytes(TRUNCATION_MARKER) && (head > 0 || tail > 0)){
        if (tail >= head && tail > 0) tail -= 1;
        else head -= 1;
        cut = `${chars.slice(0, head).join('')}${TRUNCATION_MARKER}${chars.slice(chars.length - tail).join('')}`;
    }
    const fitted = [
        ...turns
    ];
    fitted[longest] = cut;
    return fitted;
}
var serving_budgets_namespaceObject = /*#__PURE__*/ JSON.parse('{"R":{"crown-dsl":{"maxUser":24576,"maxNew":24573,"maxSeq":49152},"query":{"maxUser":40960,"maxNew":8189,"maxSeq":49152},"form-extract":{"maxUser":40960,"maxNew":8189,"maxSeq":49152},"schema-author":{"maxUser":16384,"maxNew":32765,"maxSeq":49152},"schema-author-big":{"maxUser":16384,"maxNew":32765,"maxSeq":49152},"orchestrator":{"maxUser":40960,"maxNew":8189,"maxSeq":49152},"nl-base":{"maxUser":4096,"maxNew":2048,"maxSeq":6272},"statistics":{"maxUser":16384,"maxNew":32765,"maxSeq":49152},"json-render":{"maxUser":16384,"maxNew":32765,"maxSeq":49152},"maths":{"maxUser":16384,"maxNew":32765,"maxSeq":49152},"genomics":{"maxUser":16384,"maxNew":32765,"maxSeq":49152},"algorithms":{"maxUser":16384,"maxNew":32765,"maxSeq":49152}}}');
export { fitTurnsToWindow, serving_budgets_namespaceObject };
